import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faVenusMars, faCalendar, faGlobe, faArrowsUpDown,
  faDroplet, faEye, faDumbbell, faBriefcase,
} from '@fortawesome/free-solid-svg-icons';
import UserDetailsEdit from "./UserDetailsEdit";
import { AGE_OPTIONS } from '../../../constants/AgeOptions';
import { ETHNICITY_OPTIONS } from '../../../constants/EthnicityOptions';

const DETAIL_CONFIG = [
  { key: 'gender',    label: 'Playing Gender',      icon: faVenusMars   },
  { key: 'age',       label: 'Playing Age Range',   icon: faCalendar    },
  { key: 'ethnicity', label: 'Ethnicity',            icon: faGlobe       },
  { key: 'height',    label: 'Height',               icon: faArrowsUpDown},
  { key: 'hairColor', label: 'Hair Color',           icon: faDroplet     },
  { key: 'eyesColor', label: 'Eye Color',            icon: faEye         },
  { key: 'bodyBuild', label: 'Body Build',           icon: faDumbbell    },
  { key: 'hasAgent',  label: 'Has Representation',  icon: faBriefcase   },
];

export default function UserDetails({ data, isEditMode, onChange, errors, clearError }) {
  const { t } = useTranslation();

  const getDisplayValue = (key) => {
    const val = data?.[key];
    if (val === undefined || val === null || val === '') return null;

    if (key === 'hasAgent') return val === true ? t('Yes') : val === false ? t('No') : null;
    if (key === 'age') {
      const match = AGE_OPTIONS.find(o => String(o.value) === String(val));
      return match ? t(match.label) : String(val);
    }
    if (key === 'ethnicity') {
      const match = ETHNICITY_OPTIONS.find(o => String(o.value) === String(val));
      return match ? t(match.label) : String(val);
    }
    return t(String(val));
  };

  return (
    <section className="tw-w-full tw-bg-transparent tw-py-12">
      <div className="tw-w-full tw-max-w-[1280px] tw-mx-auto tw-px-4 md:tw-px-0">

        <h2 className="tw-text-[#FF43A7] tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-widest tw-mb-8">
          {t('Actor Details')}
        </h2>

        <div className="tw-pl-0 md:tw-pl-10">
          {isEditMode ? (
            <UserDetailsEdit data={data} onChange={onChange} errors={errors} clearError={clearError} />
          ) : (
            <div className="tw-bg-[#280D41] tw-border tw-border-[#5A3F49]/40 tw-rounded-[24px] tw-p-6 md:tw-p-10">
              <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-6 md:tw-gap-8">
                {DETAIL_CONFIG.map(({ key, label, icon }) => {
                  const value = getDisplayValue(key);
                  return (
                    <div key={key} className="tw-flex tw-flex-col tw-gap-2">
                      <div className="tw-flex tw-items-center tw-gap-2">
                        <FontAwesomeIcon icon={icon} className="tw-text-[#FF43A7] tw-text-xs tw-w-3 tw-flex-shrink-0" />
                        <p className="tw-text-[10px] tw-text-[#AA8894] tw-uppercase tw-tracking-widest tw-font-bold tw-m-0">
                          {t(label)}
                        </p>
                      </div>
                      <p className="tw-font-medium tw-text-base tw-text-white tw-m-0 tw-pl-5">
                        {value || <span className="tw-text-[#5A3F49]">--</span>}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
